// DashboardSummary.jsx — Wave 2A: restrained operational KPI row.
// Presentation only: receives already-computed metrics, owns zero logic.
// Compact, information-dense, quiet. Canonical semantic tones only.

import React from "react";
import { Inbox, BellOff, Send, Archive, FileClock } from "lucide-react";

const TONES = ["warning", "danger", "info", "success", "neutral"];

const DashboardSummary = ({ items }) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <section className="wvd-summary" aria-label="Operational summary">
      {items.map(({ key, label, value, context, tone = "neutral", icon: Icon }) => {
        const safeTone = TONES.includes(tone) ? tone : "neutral";
        const IconToUse = Icon || FileClock;
        return (
          <div key={key || label} className={`wvd-summary__card wvd-summary__card--${safeTone}`}>
            <span className="wvd-summary__icon">
              <IconToUse size={20} aria-hidden="true" />
            </span>
            <span className="wvd-summary__meta">
              <span className="wvd-summary__label">{label}</span>
              <span className="wvd-summary__value">{value}</span>
              {context ? <span className="wvd-summary__context">{context}</span> : null}
            </span>
          </div>
        );
      })}
    </section>
  );
};

// Convenience icon picks for the standard WAVY queue metrics.
DashboardSummary.icons = { inbox: Inbox, missed: BellOff, sent: Send, archive: Archive, clock: FileClock };

export default DashboardSummary;
